import { useState } from 'react'

import { VoidFunction } from '@js/common/types/FunctionTypes'

export type TransitionState =
  | 'idle'
  | 'animatingValidation'
  | 'animatingAccountCreation'
  | 'complete'

export interface QuizTransition {
  state: TransitionState
  startValidationAnimation: VoidFunction
  startAccountCreationAnimation: VoidFunction
  completeTransition: VoidFunction
}

export const useQuizTransition = (
  initialState?: TransitionState
): QuizTransition => {
  const [state, setTransitionState] = useState<TransitionState>(
    initialState || 'idle'
  )

  function startValidationAnimation() {
    setTransitionState('animatingValidation')
  }

  function startAccountCreationAnimation() {
    setTransitionState('animatingAccountCreation')
  }

  function completeTransition() {
    setTransitionState('complete')
  }

  return {
    state,
    startValidationAnimation,
    startAccountCreationAnimation,
    completeTransition
  }
}
